const getScope = (state) => state.modules.quotes.quantitiesModal;

export const getIsQuantitiesModalOpen = (state) =>
  getScope(state).isQuantitiesModalOpen;

export const getIsQuantitiesUpdating = (state) =>
  getScope(state).isQuantitiesUpdating;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export const getComponentId = (state) => getScope(state).componentId;
